import React from 'react';
import ZInput from '../../../z-input';
import ZTextArea from '../../../z-text-area';
import style from './text-block-body.module.scss';

const TextBlockBodyView = ({
  title,
  text,
  onTitleChange,
  onTextChange,
}) => {
  return (
    <>
      <h2>Text Block Body</h2>
      <div className={style['container']}>
        <ZInput
          label='Title'
          onUpdate={onTitleChange}
          initialValue={title}
          inputKey={'textBlockBody__title'}
        />
        <ZTextArea
          allowedFormats={['ITALICS','BOLD','LINKS']}
          label='Text'
          onUpdate={onTextChange}
          value={text}
          inputKey={'textBlockBody__text'}
          openInternalLinksInNewTab
        />
      </div>
    </>
  );
}

export default TextBlockBodyView;


